var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddUser = function SvgAddUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.75a.75.75 0 0 0 1.5 0v-3h3a.75.75 0 0 0 0-1.5h-3v-3a.75.75 0 0 0-1.5 0v3h-3a.75.75 0 0 0 0 1.5h3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.25 9.75a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0m-1.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M13.5 18.75c0 2.071-2.686 3.75-6 3.75s-6-1.679-6-3.75S4.186 15 7.5 15s6 1.679 6 3.75m-1.5 0c0 .332-.22.859-1.052 1.38-.812.507-2.027.87-3.448.87s-2.636-.363-3.448-.87C3.22 19.609 3 19.082 3 18.75s.22-.859 1.052-1.38c.812-.507 2.027-.87 3.448-.87s2.636.363 3.448.87c.833.521 1.052 1.048 1.052 1.38",
    clipRule: "evenodd"
  })));
};
export default SvgAddUser;